import { apiPost } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';
import { IDecisionListFilterParams } from 'DecisionListPackage/MainModule/interfaces/IDecisionListFilterParams';

import { IDecisionResponse } from '../interfaces/IDecisionResponse';

export function fetchDecisions(
  page = 0,
  size = 50,
  filter: IDecisionListFilterParams | null,
  order = '',
): Promise<IDecisionResponse> {
  const params = new URLSearchParams();

  params.set('page', String(page));
  params.set('size', String(size));
  order && params.set('order', order);

  return apiPost<IDecisionResponse>({
    url: `${getServiceBaseURL(APIServiceEnum.INDEX_SERVICE)}/decision-passport/find-indexes?${params}`,
    body: filter,
  });
}
